<script setup lang="ts">

const props = defineProps({isActive:{
    type: Boolean || null,
    defaut: true
}})



</script>

<template>
    <div :class="[props.isActive? 'cursor-pointer active:bg-primary-300' : 'cursor-inherit']" class="w-9 h-9 bg-primary-100 rounded-xs flex items-center justify-center relative ">
        <div :class="[props.isActive? 'border-white' : 'border-gray-300']" class="absolute w-6 border rounded-full"   ></div>
    </div>
</template>